<template>
    <div class="components-container">
        <el-form class="small-space" :model="createdForm" ref="createdForm" label-position="right" label-width="200px"
            width="100%">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="编号" class="form-item-font" prop="jpBh">
                        <el-input :disabled="true" v-model="createdForm.jpBh" placeholder="自动生成"></el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="12">
                    <el-form-item label="状态" class="form-item-font">
                        <div v-if="createdForm.jpTjzt == '-1'" class="status" style="background-color: #808080">
                            未保存
                        </div>
                        <div v-else-if="createdForm.jpTjzt == '0'" class="status" style="background-color: #e6a23c">
                            未提交
                        </div>
                        <div v-else-if="createdForm.jpTjzt=='1' && createdForm.jpShzt==''" class="status" style="background-color: #409eff">
                            待审核
                        </div>
                        <div v-else-if="createdForm.jpShzt == '1'" class="status" style="background-color: #67c23a">
                            审核通过
                        </div>
                        <div v-else-if="createdForm.jpShzt == '2'" class="status" style="background-color: #f56c6c">
                            审核驳回
                        </div>
                        <div v-else></div>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="12">
                    <el-form-item label="起效学年" class="form-item-font">
                        <el-select class="formInput" v-model="createdForm.jpXn" placeholder="请选择起效学年" @change="handlechange"
                            :disabled="isEdit">
                            <el-option v-for="item in terms" :key="item.comboValue" :label="item.comboName" :value="item.comboValue"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <!--
                <el-col :span="12">
                    <el-form-item label="模式" class="form-item-font">
                        <el-select class="formInput" v-model="createdForm.jpMsdm" placeholder="请选择模式" @change="handlechange"
                            :disabled="isEdit">
                            <el-option v-for="item in mode" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                -->
                <el-col :span="12">
                    <el-form-item label="学制" class="form-item-font">
                        <el-input v-model="createdForm.institution"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="专业名称（代码）" class="form-item-font" prop="jpZydm">
                        <el-select class="formInput" v-model="createdForm.jpZydm" placeholder="请选择专业名称（代码）" @change="handlechange"
                            :disabled="isEdit" filterable>
                            <el-option v-for="item in majors" :key="item.comboValue" :label="item.comboName" :value="item.comboValue"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="专业别名" class="form-item-font" prop="jpZybm">
                        <el-input v-model="createdForm.jpZybm" :disabled="editDisableState"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="编制人" class="form-item-font">
                        <el-input :disabled="true" placeholder="自动生成" v-model="createdForm.userName"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="发布日期" class="form-item-font">
                        <el-date-picker class="formInput" v-model="createdForm.jpFbrq" value-format="yyyy-MM-dd" :disabled="editDisableState" placeholder="请选择日期"></el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>
			<el-row>
			    <el-col :span="24">
			        <el-form-item label="指定班级" class="form-item-font" prop="jpGlbjbh">
			            <el-select class="formInput" :disabled="editDisableState" v-model="createdForm.jpGlbjbh" placeholder="" multiple filterable>
			                <el-option v-for="item in classInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue"></el-option>
			            </el-select>
			        </el-form-item>
			    </el-col>
			</el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="入学要求" class="form-item-font" prop="jpRxyq">
                        <el-input :disabled="editDisableState" v-model="createdForm.jpRxyq"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-row>
                        <div class="titles">
                            <span class="fonts">培养目标</span>
                        </div>
                    </el-row>
                    <el-input v-model="createdForm.jpPymb" type="textarea" :autosize="{ minRows: 5, maxRows: 5 }"
                        :disabled="editDisableState" maxlength="1000" show-word-limit></el-input>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>

<script>
    export default {
        props: ["isEdit", "editDisableState", "classInfo"],
        data() {
            return {
                labelPosition: "right",
                createdForm: {
                    jpBh: "",
                    jpXn: "",
                    jpMsdm: "",
                    jpZydm: "",
                    jpZybm: "",
                    jpRxyq: "",
                    jpPymb: "",
                    jpCjr: "",
                    userName: "",
                    jpYjlj: "",
                    jpYjwjm: "",
                    institution: "3",
                    jpTjzt: "",
                    jpShzt: "",
                    jpFbrq: "",
                    jpGlbjbh: "",
                },
                majors: [],
                classes: [],
                terms: [],
                mode: [],
            };
        },
        mounted() {
            this.loadMajors();
            this.loadMode();
            this.loadTerms();
        },
        methods: {
            loadMajors() {
                this.$api.common.comboOption.major().then((response) => {
                    this.majors = response.data.data.comboData;
                }).catch((err) => console.log(err));
                /* this.$api.teachingManage.teachingScheme
                    .loadMajors()
                    .then((res) => {
                        this.majors = res.data;
                    })
                    .catch((err) => console.log(err)); */
            },
            /* classOption() {
                const params = {
                    "workYear": this.createdForm.jpXn,
                    "majorCode": this.createdForm.jpZydm,
                }
                this.$api.teachingManage.teachingScheme.classOption({
                    data: params,
                }).then((response) => {
                    this.classInfo = response.data.data.class;
                }).catch((error) => {
                    console.log(error);
                });
            }, */
            loadTerms() {
                this.$api.common.comboOption.year().then((response) => {
                    this.terms = response.data.data.comboData;
                }).catch((err) => console.log(err));
                /* this.$api.teachingManage.teachingScheme
                    .loadTerms()
                    .then((res) => {
                        this.terms = res.data;
                    })
                    .catch((err) => console.log(err)); */
            },
            loadMode() {
                this.$api.teachingManage.teachingScheme
                    .loadMode()
                    .then((res) => {
                        this.mode = res.data;
                    })
                    .catch((err) => console.log(err));
            },
            handlechange() {
                // if (this.createdForm.jpMsdm!="" && this.createdForm.jpZydm!="" && this.createdForm.jpXn!="") {
                if (this.createdForm.jpZydm!="" && this.createdForm.jpXn!="") {
                    // let id = this.createdForm.jpXn + this.createdForm.jpZydm + this.createdForm.jpMsdm;
                    let id = this.createdForm.jpXn + this.createdForm.jpZydm;
                    let param = {
                        jpBh: id,
                    };
                    this.$api.teachingManage.teachingScheme.isRepeat({
                        data: param,
                    }).then((res) => {
                        if (res.data) {
                            this.$notify({
                                title: "错误",
                                message: "已有同学年同专业的人才培养方案",
                                type: "error",
                                duration: 3000,
                            });
                            this.createdForm.jpXn = "";
                            this.createdForm.jpZydm = "";
                            this.createdForm.jpMsdm = "";
                            this.createdForm.jpGlbjbh = "";
                            this.createdForm.jpBh = "系统自动生成";
                            return;
                        }
                    }).catch((err) => {
                        console.log(err);
                    });

                    this.createdForm.jpBh = id;
                }

                this.$emit("loadParams", this.createdForm.jpBh);
            },
        },
    };
</script>

<style scoped>
    .formInput {
        width: 100%;
    }

    .status {
        width: 100px;
        height: 40px;
        line-height: 40px;
        color: #ffffff;
        font-size: 16px;
        font-weight: bold;
        border: 2px solid;
        border-radius: 8px;
        margin-left: 10px;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// teachingForm.vue?6cb44184